import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { TrafficMarshalReport } from "../../../Apis/TransferStationReport/trafficMarshalAPI";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
const TrafficMarshlTransactionReport = ({ t }) => {
  const headers = [
    "trafficMarshalName",
    "operationTypeName",
    // "vehicleUid",
    // "containerUid",
    "vehicleNumber",
    "vehicleTypeName",
    "containerCode",
    "ownerTypeName",
    "operationInTime",
    "operationOutTime",
    "totalTimeSpentInMinutes",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);

  const [VehicleNumber, setVehicleNumber] = useState("");
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  //   const fetchTripsTonnageData = async (startDate, endDate) => {
  //     try {
  //       setIsLoading(true);

  //       const response = await TrafficMarshalReport(startDate, endDate);
  //       const formattedData = response.data.map((item) => ({
  //         ...item,
  //         trafficMarshalName:item.trafficMarshalName,
  //         operationTypeName: item.operationTypeName,
  //         vehicleUID: item.vehicleUuid,
  //         vehicleNumber: item.vehicleNumber,
  //         vehicleTypeName: item.vehicleTypeName,
  //         ownerTypeName:item.ownerTypeName,
  //         operationInTime:item.operationInTime,
  //         operationOutTime:item.operationOutTime,
  //         totalTimeSpentInMinutes:item.totalTimeSpentInMinutes,
  //         containerUID:item.containerUuid,
  //         containerCode:item.containerCode
  //       }));
  //       setAllTripsTonnage(formattedData);
  //       console.log(formattedData,'formatted Dataaaa');
  //       setIsLoading(false); // After data fetching is done, set isLoading to false
  //     } catch (error) {
  //       console.log(error);
  //       setIsLoading(false); // In case of error, also set isLoading to false
  //     }
  //   };

  const fetchTripsTonnageData = async (startDate, endDate, VehicleNumber) => {
    try {
      setIsLoading(true);

      const response = await TrafficMarshalReport(
        startDate,
        endDate,
        VehicleNumber
      );

      // Check the structure of the response data
      if (Array.isArray(response.data.data)) {
        const formattedData = response.data.data.map((item, index) => {
          console.log(`Item ${index}:`, item); // Log each item to inspect its structure
          return {
            trafficMarshalTransactionId: item.trafficMarshalTransactionId || 'N/A',
            attendanceId: item.attendanceId || 'N/A',
            trafficMarshalId: item.trafficMarshalId || 'N/A',
            trafficMarshalName: item.trafficMarshalName || 'N/A',
            operationTypeId: item.operationTypeId || 'N/A',
            operationTypeName: item.operationTypeName || 'N/A',
            vehicleUid: item.vehicleUuid || 'N/A',
            vehicleNumber: item.vehicleNumber || 'N/A',
            vehicleTypeId: item.vehicleTypeId || 'N/A',
            vehicleTypeName: item.vehicleTypeName || 'N/A',
            ownerTypeId: item.ownerTypeId || 'N/A',
            ownerTypeName: item.ownerTypeName || 'N/A',
            operationInTime: item.operationInTime || 'N/A',
            operationOutTime: item.operationOutTime || 'N/A',
            totalTimeSpentInMinutes: item.totalTimeSpentInMinutes || 'N/A',
            containerUid: item.containerUuid || 'N/A',
            containerTypeId: item.containerTypeId || 'N/A',
            containerId: item.containerId || 'N/A',
            containerCode: item.containerCode || 'N/A',
          };
        });
        setAllTripsTonnage(formattedData);
        console.log(formattedData, "formatted Data");
      } else {
        console.log("Unexpected response format:", response.data);
      }

      setIsLoading(false); // After data fetching is done, set isLoading to false
    } catch (error) {
      console.log(error);
      setIsLoading(false); // In case of error, also set isLoading to false
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, VehicleNumber);
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Traffic Marshal Transaction Reports (${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}) (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 11); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Traffic Marshal Transaction Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 11); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Traffic Marshal Transaction Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Traffic Marshal Name",
      "Operation Type Name",
      // "Vehicle UID",
      // "Container UID",
      "Vehicle Number",
      "Vehicle Type Name",
      "Container Code",
      "Owner Type Name",
      "Operation In Time",
      "Operation Out Time",
      "Total Time Spent In Minutes",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 12) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.trafficMarshalName || 'N/A',
          item.operationTypeName || 'N/A',
          // item.vehicleUid || 'N/A',
          // item.containerUid || 'N/A',
          item.vehicleNumber || 'N/A',
          item.vehicleTypeName || 'N/A',
          item.containerCode || 'N/A',
          item.ownerTypeName || 'N/A',
          item.operationInTime || 'N/A',
         item.operationOutTime || 'N/A',
         item.totalTimeSpentInMinutes || 'N/A'
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 12) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TrafficMarshalTransactionReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {isLoading ? ( // Check isLoading state and show loader if true
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 class="text-start mb-3">
                Traffic Marshal Transaction Report ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-10">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row" style={{ textAlign: "left" }}>
                          <div className="col-md-3 ">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              className="form-control"
                              value={startDate}
                              min={getOneMonthPastDateTime()}
                              max={getNowDateTime()}                            
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              min={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label>Vehicle Number</label>
                            <input
                              type="text"
                              name="vehicleTypeCode"
                              style={FilterInputStyle}
                              placeholder="Vehicle Number"
                              value={VehicleNumber}
                              onChange={(e) => {
                                setVehicleNumber(
                                  e.target.value.replace(/\s+/g, "")
                                );
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <button
                              type="submit"
                              className={`btn mt-4 ${
                                isProd ? "search-ghmc" : "search-swm"
                              }`}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="col-md-2 ">
                      <button
                        className="btn btn-excel ms-auto mt-4"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                        Excel
                      </button>
                    </div>
                  </div>

                  <div className="mt-3">
                    {/* <div className="top-header">
                  <span>{t("Primary Deployment Transaction Report")} </span>
                </div> */}
                    <TableComponent
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                      filterFunction={(data) =>
                        data.filter(
                          (item) => item.status === 1 || item.status === 2
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Rest of the component remains the same

export default withTranslation()(TrafficMarshlTransactionReport);

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};
const FilterInputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};
const buttonStyle = {
  border: "1px solid #E2E2E2",
  marginTop: "29px",
  borderRadius: "5px",
  color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
